
<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>Lists</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <div class="wemail-overview-content">
        <ListsTable/>
      </div>
    </div>
  </a-layout-content>
</template>
<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import ListsTable from "@/components/ListsTable.vue";
export default {
  components: {
    SitesNavigation,
    ListsTable
  }
};
</script>
<style scoped>
.wemail-sites-overview {
  margin: 30px;
}
.wemail-overview-content {
  padding: 15px;
  background: #fafafa;
}
.wemail-overview-content table {
  border: 1px solid #e8e8e8;
}
.wemail-tabs-wrap {
  border: 1px solid #d9d9d9;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  margin: 16px;
  font-size: 1.3em;
  text-align: center;
  color: #fff;
}
</style>
